<template>
  <div class="page-customs-doc">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">報表統計</div>
      <div class="breadcrumb-item">報關資料</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select
            size="small"
            placeholder="提貨櫃點"
            v-model="form.arrive"
            clearable
          >
            <Option
              :value="item.ReceivingID"
              v-for="(item, index) in pickAddress"
              :key="item.ReceivingID"
              >({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select size="small" placeholder="業務類型" v-model="form.goods_type">
            <Option :value="0">無</Option>
            <Option
              :value="item.id"
              v-for="(item, index) in packageType"
              :key="item.id"
            >
              {{ item.describe }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            size="small"
            placeholder="公司列表"
            v-model="form.order_parent"
            :clearable="userInfo.user_role == 1"
          >
            <Option
              :value="item.id"
              v-for="(item, index) in samcityType"
              :key="item.id"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            size="small"
            placeholder="收件方式"
            v-model="form.arrive_type"
            clearable
          >
            <Option value="1">門店</Option>
            <Option value="2">智能櫃</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            size="small"
            placeholder="操作人"
            v-model="form.admin_id"
            clearable
          >
            <Option
              :value="item.user_id"
              v-for="(item, index) in pickAdmin"
              :key="item.user_id"
              >{{ item.username }} ({{ item.realname }})
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            placeholder="珠海倉庫入庫-開始日期"
            v-model="form.start_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
            :editable="false"
            clearable
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            placeholder="珠海倉庫入庫-結束日期"
            v-model="form.end_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            style="width: 100%"
            :editable="false"
            clearable
          ></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input
            size="small"
            v-model="form.odd_numbers"
            @keyup.enter.native="handleSearch()"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶名稱</label>
          <Input
            size="small"
            v-model="form.recipient_contacts"
            @keyup.enter.native="handleSearch()"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶電話</label>
          <Input
            size="small"
            v-model="form.phone"
            @keyup.enter.native="handleSearch()"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">袋號</label>
          <Input
            size="small"
            v-model="form.sack_number"
            @keyup.enter.native="handleSearch()"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <div class="pg-btn style2" @click="handleExport">導出excel</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
      <Table
        size="small"
        border
        no-data-text="暫無數據"
        :columns="table.column"
        :data="table.data"
      >
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="12" class="pagger-right">
            <div class="pagger-sizer">
              <span>每頁</span>
              <Select v-model="curPageSize" size="small" placeholder="數量">
                <Option :value="10">10</Option>
                <Option :value="20">20</Option>
                <Option :value="30">30</Option>
                <Option :value="40">40</Option>
                <Option :value="50">50</Option>
              </Select>
            </div>

            <div class="pagger-elevator">
              <span>跳轉</span>
              <Input
                size="small"
                v-model="pageInput"
                @on-keyup="handlePageInput"
                @on-enter="handlePageEnter"
              />
            </div>

            <Page
              size="small"
              :current="pageIndex"
              :page-size="curPageSize"
              :total="totalCount"
              @on-selection-change="select_change"
              @on-change="handlePageChange"
            >
            </Page>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import dayjs from "dayjs";

export default {
  data() {
    return {
      userInfo: localStorage.getItem("jyb_logInfo")
        ? JSON.parse(localStorage.getItem("jyb_logInfo"))
        : {},
      create_date: "",
      pageIndex: 1, //页码
      curPageSize: 10, //一页数量
      totalCount: 1, //总条数
      money: 0,
      sum: 0,
      business: 2900065,
      pageInput: "", //输入的页码
      pickAddress: [], //提貨櫃點
      packageType: [], //包裹類型
      pickAdmin: [],
      selectid: [],
      samcityType: [], //同城
      form: {
        arrive: "", //提货柜点
        arrive_type: "", //收件方式，1门店，2智能柜
        goods_type: 0, //包裹类型
        start_time: "",
        end_time: "",
        recipient_contacts: "", //客户名称
        phone: "", //客户手机号
        odd_numbers: "", //快递单号
        sack_number: "", //袋号
        admin_id: "",
        order_parent: "",
        // packet_id: '',
        // outgoing:''
      },
      isSubmiting: false,
      exportLink: "", //导出地址
      table: {
        column: [
          // {
          //     type: 'selection',
          //     minWidth: 60,
          //     align: 'center',
          // },
          {
            title: "客戶名稱",
            key: "name",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          {
            title: "賬冊資料",
            key: "file",
            align: "center",
            sortable: true,
            minWidth: 110,
          },
          {
            title: "賬冊序號",
            key: "fileId",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "HS碼",
            key: "hsCode",
            align: "center",
            sortable: true,
            minWidth: 150,
          },
          {
            title: "包裹小類",
            key: "packageType",
            align: "center",
            sortable: true,
            minWidth: 150,
          },
          {
            title: "數量",
            key: "count",
            align: "center",
            sortable: true,
            minWidth: 50,
          },
          {
            title: "毛重",
            key: "totalWeight",
            align: "center",
            sortable: true,
            minWidth: 50,
          },
          {
            title: "長度",
            key: "length",
            align: "center",
            sortable: true,
            minWidth: 50,
          },
          {
            title: "寬度",
            key: "width",
            align: "center",
            sortable: true,
            minWidth: 50,
          },
          {
            title: "高度",
            key: "height",
            align: "center",
            sortable: true,
            minWidth: 50,
          },
          {
            title: "出貨重量",
            key: "weight",
            align: "center",
            sortable: true,
            minWidth: 60,
          },
          {
            title: "運費",
            key: "fee",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "到貨運費",
            key: "freight_collect",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "提貨櫃點序號",
            key: "goodsId",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "提貨櫃點",
            key: "address",
            align: "center",
            sortable: true,
            minWidth: 150,
          },
          {
            title: "商家",
            key: "business",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "運單號",
            key: "orderNo",
            align: "center",
            sortable: true,
            minWidth: 160,
          },
          {
            title: "袋號",
            key: "packageNo",
            align: "center",
            sortable: true,
            minWidth: 150,
          },
          {
            title: "創單時間",
            key: "create_date",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
        ],
        data: [],
      },
    };
  },
  mounted() {
    this.getPickAddress();
    this.getPackageType();
    this.getPickAdmin();
    this.getSamcityList();
  },
  watch: {
    curPageSize() {
      this.getList();
    },
  },
  methods: {
    select_change(selection) {},
    getSamcityList() {
      const userInfo = localStorage.getItem("jyb_logInfo")
        ? JSON.parse(localStorage.getItem("jyb_logInfo"))
        : {};
      this.$Rq
        .requestAuth({
          url: this.$Api.samecityUserList,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            if (userInfo.parent_id == 1) {
              this.samcityType = res.data.data;
            } else {
              this.samcityType = res.data.data.filter(
                (it) => it.id == userInfo.parent_id
              );
            }
            if (this.samcityType.length == 1) {
              this.form.order_parent = this.samcityType[0].id;
            }
          }
        });
    },
    //提貨櫃點
    getPickAddress() {
      const userInfo = localStorage.getItem("jyb_logInfo")
        ? JSON.parse(localStorage.getItem("jyb_logInfo"))
        : {};
      let company_id = userInfo.parent_id == 1 ? 0 : userInfo.parent_id;
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: company_id,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(
              (it) => it.company_id != 15
            );
            if (res.data.data.length <= 1) {
              this.form.arrive = res.data.data[0].ReceivingID;
            }
            this.getList();
          }
        });
    },
    //操作人
    getPickAdmin() {
      const userInfo = localStorage.getItem("jyb_logInfo")
        ? JSON.parse(localStorage.getItem("jyb_logInfo"))
        : {};
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAdmin,
          method: "post",
        })
        .then((res) => {
          if (res.code == 0) {
            if (userInfo.parent_id == 1) {
              this.pickAdmin = res.data.data;
            } else {
              this.pickAdmin = res.data.data.filter(
                (it) => it.parent_id == userInfo.parent_id
              );
            }
          }
        });
    },
    //包裹類型
    getPackageType() {
      this.$Rq
        .requestAuth({
          url: this.$Api.packageType,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.packageType = res.data.data;
          }
        });
    },
    formatDate(datetime) {
      if (!datetime) return "";

      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    getList() {
      let form = this.form;
      // this.isLoading = true;
      this.isSubmiting = true;
      this.$Rq
        .requestAuth({
          url: this.$Api.scanIn,
          method: "get",
          data: {
            status: -2, //0待出库, 1已出库
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            arrive: form.arrive,
            arrive_type: form.arrive_type,
            goods_type: form.goods_type,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
            recipient_contacts: form.recipient_contacts,
            phone: form.phone,
            odd_numbers: form.odd_numbers,
            sack_number: form.sack_number,
            admin_id: form.admin_id,
            order_parent: form.order_parent,
            // packet_id: form.packet_id,
            // outgoing: form.outgoing
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            let tempArr = [];
            let resData = res.data.data;
            for (let i = 0; i < resData.length; i++) {
              tempArr.push({
                id: resData[i].id,
                name: resData[i].recipient_contacts,
                file: resData[i].recipient_phone,
                fileId: resData[i].id,
                hsCode: resData[i].detailed.code,
                goodsId:
                  resData[i].store != null
                    ? resData[i].store.cainiao_match
                    : "無",
                packageType: resData[i].detailed.name,
                count: resData[i].count,
                totalWeight: resData[i].volume_weight,
                length: resData[i].long,
                width: resData[i].wide,
                height: resData[i].height,
                weight: resData[i].weight,
                address:
                  resData[i].store != null
                    ? resData[i].store.ReceivingName
                    : "無",
                orderNo: resData[i].odd_numbers,
                packageNo: resData[i].sack_number,
                fee: Math.round(
                  parseFloat(resData[i].freight_collect) +
                    parseFloat(resData[i].amount) +
                    parseFloat(resData[i].surcharge_price)
                ),
                create_date: resData[i].created_at,
                business: "2900056",
                receiveType: "",
                freight_collect: resData[i].freight_collect,
              });
            }
            this.totalCount = res.data.count;
            this.sum = Math.round(res.data.sum);
            this.money = Math.round(res.data.money);
            this.table.data = tempArr;
          }
        })
        .catch((err) => {
          // this.isLoading = false;
          this.isSubmiting = false;
        });
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    handleExport() {
      let token = localStorage.getItem("jyb_token");
      let form = this.form;
      if (!form.start_time) {
        this.$Utils.showTipInfo("請選擇起始時間");
        return;
      }
      if (!form.end_time) {
        this.$Utils.showTipInfo("請選擇结束時間");
        return;
      }
	
	    const start_time = dayjs(form.start_time).format("YYYY-MM-DD HH:mm:ss");
	    const end_time = dayjs(form.end_time).format("YYYY-MM-DD HH:mm:ss");
      let params = {
        Authorization: token,
        flag: 3,
        status: -2, //0待出库, 1已出库
        arrive: form.arrive,
        arrive_type: form.arrive_type,
        goods_type: form.goods_type,
        start_time: start_time,
        end_time: end_time,
        recipient_contacts: form.recipient_contacts,
        phone: form.phone,
        odd_numbers: form.odd_numbers,
        sack_number: form.sack_number,
        admin_id: form.admin_id,
        order_parent: form.order_parent,
        // packet_id: form.packet_id,
        // outgoing: form.outgoing
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);
      this.getList();
      // this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
      window.open(`${this.$Api.deliverFexport}?${formatParams}`, "_blank");
    },
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },
    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },
    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "CustomsDoc.scss";
</style>
